import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-change-text-field-modal',
  templateUrl: './change-text-field-modal.component.html',
  styleUrls: ['./change-text-field-modal.component.scss'],
  standalone: false
})
export class ChangeTextFieldModalComponent implements OnInit {
  @Input() currentText = '';
  @Input() placeholder = '';
  @Input() maxLength = 500;
  @Input() title = 'Atención';
  @Input() label = '';
  @Input() rows = 3;
  @Input() allowEmpty = false;
  @Input() titleIcon = "assets/icon/alert-red-circle.svg";

  constructor(protected modalController: ModalController) {
  }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    if (!this.currentText.length && !this.allowEmpty) {
      return;
    }
    this.modalController.dismiss(({
      newText: this.currentText,
    }));
  }
}
